import { DateTime } from "@/Common/Helpers/DateTime";
import { FileSelectionHelper } from "@/Common/Helpers/FileSelectionHelper";
import { FileType } from "@/Common/Models/FileType";
import { ExportableFile, IExportableFileLoaded } from "../ExportableFile";
import { GenerateFileOptions } from "../IGenerateFileOptions";

class FileTypeMedicationSummary extends ExportableFile {
    public canGenerateFileXcom: boolean = true;

    public PatientContactId: string;

    constructor(patientContactId: string) {
        super(FileType.MEDICATIONSUMMARY);
        this.PatientContactId = patientContactId;
        this.description = cacheStore.GetString("MedicationSummaryLabel");
        this.date = DateTime.now();
    }

    public getAttachedObject_ObjectId(): string { return this.PatientContactId; }

    public getCleanCopy(): FileTypeMedicationSummary {
        return new FileTypeMedicationSummary(this.PatientContactId);
    }

    public async getMeta(): Promise<number> {
        throw "Not implemented";
    }

    protected async generateFileIfNeededXcom(includeOverlays: boolean): Promise<IExportableFileLoaded> {
        return await this.generateFileIfNeeded({ includeOverlays: includeOverlays, isExternal: true });
    }

    protected generateFileIfNeeded(generateFileOption: GenerateFileOptions): Promise<IExportableFileLoaded> {
        const { isExternal } = generateFileOption;
        const fetchUrl =
            isExternal
                ? FileSelectionHelper.getFetchUrlXcom(this.clientTag, this.claimId, this.PatientContactId, this.fileType, { noCache: true })
                : FileSelectionHelper.getFetchUrl(this.PatientContactId, this.fileType, { noCache: true });

        return new Promise(resolve => resolve({
            OriginalExportableFile: this,
            FetchUrl: fetchUrl
        }));
    }
}

export { FileTypeMedicationSummary };
